/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentFolders.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Folder API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Monday, November 19, 2018 - 06:07:58 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      11/19/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Folders = {
    all: (parentid) => requests.get(`/Folders?parentid=${parentid}`),
    folderTree: () => requests.get('/FolderTree'),
    getContents: (folderid) => requests.get(`/FolderContents?folderid=${folderid}`),
    get: folderid => requests.get(`/Folder/${folderid}`),
    create: folder => requests.post(`/Folders`, folder),
    update: (folderid, folder) => requests.put(`/Folder/${folderid}`, folder),
    delete: folderid => requests.del(`/Folder/${folderid}`),
};

export const Documents = {
    get: documentid => requests.get(`/Document/${documentid}`),
    create: document => requests.post(`/Documents`, document),
    update: (documentid, document) => requests.put(`/Document/${documentid}`, document),
    delete: documentid => requests.del(`/Document/${documentid}`),
};

export const Files = {
    get: fileid => requests.get(`/File/${fileid}`),
    create: file => requests.post(`/Files`, file),
    update: (fileid, file) => requests.put(`/File/${fileid}`, file),
    delete: fileid => requests.del(`/File/${fileid}`),
};

export const Images = {
    get: imageid => requests.get(`/Image/${imageid}`),
    create: image => requests.post(`/Images`, image),
    update: (imageid, image) => requests.put(`/Image/${imageid}`, image),
    delete: imageid => requests.del(`/Image/${imageid}`),
};


// WEBPACK FOOTER //
// ./src/agents/agentFolders.js